import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-sales-exit-intent-modal',
  templateUrl: './sales-exit-intent-modal.component.html',
  styleUrls: ['./sales-exit-intent-modal.component.scss']
})
export class SalesExitIntentModalComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { type: string, email: string }
  ) { }

  ngOnInit(): void {}
}
